import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import LinkIntercept from 'components/linkIntercept/LinkIntercept';

import flexbox from 'styles/utils/flexbox';
import { mediaQueries } from 'styles/utils/mediaQueries';

const propTypes = {
  slug: PropTypes.string.isRequired,
};

const CardContainer = ({ slug, children }) => (
  <Container>
    <LinkIntercept to={slug}>{children}</LinkIntercept>
  </Container>
);

CardContainer.propTypes = propTypes;

export default CardContainer;

const Container = styled.div`
  a {
    ${flexbox({
      display: 'inline-flex',
      flexWrap: 'wrap',
    })}

    max-width: 478px;
    margin-bottom: 33px;
    border: 1px solid;
    border-color: ${({ theme }) => theme.colors.primary.default};
    border-radius: 4px;
    box-shadow: 0 2px 4px -2px rgba(89, 84, 77, 0.16), 0 0 20px 10px rgba(89, 84, 77, 0.02);
    cursor: pointer;

    &:hover {
      transform: translate3d(0, -1px, 0);
      box-shadow: 0px 0px 30px -6px rgba(0, 0, 0, 0.2);
    }
  }

  ${mediaQueries.fromAndBelow.tablet`
    width: 100%;

    a {
      width: 100%;
    }
  `}
`;
